import DialogPage from "../DialogPage";
import {TouchableOpacity, View} from "react-native";
import React, {useContext, useEffect, useState} from "react";
import AppConfigContext from "../../../contexts/AppConfigContext";
import {Colors} from "../colors";
import {ColumnSpace, RowSpace} from "../components/_CommonComponents";
import Text from "../components/Text";
import ClientInfo from "../../../rest/jtmc/models/ClientInfo";
import TextInput from "../components/TextInput";
import FontAwesome from "../components/FontAwesome";
import LogoutPressable from "../../../components/functional-components/LogoutPressable";
import Button from "../components/Button";
import {AppFunctionsContext} from "../../../contexts/AppFunctionsContext";
import GuestConfirmationComponents from "../../../components/functional-components/GuestConfirmationComponents";
import ClientNameSetComponents from "../../../components/functional-components/ClientNameSetComponents";


export default function ClientInfoEdit(props: { navigation: any }) {

    const [name, setName] = useState("");
    const [clientInfo, setClientInfo] = useState<ClientInfo|null>(null);
    const functionsContext = useContext(AppFunctionsContext);
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    useEffect(()=>{
        reload();
    }, []);

    const reload = ()=>{
        functionsContext.appFetch.getClientInfo().then(info=>{
            setClientInfo(info);
            setName(info.name);
        })
    }

    return <DialogPage {...props} header={"اطلاعات کاربری"}>

        <Text>{`شماره همراه: ${clientInfo?.phone ?? ""}`}</Text>
        <ColumnSpace/>
        <Text>{`وضعیت شماره: ${clientInfo?.phoneVerified ?? true ? "تایید شده" : "تایید نشده"}`}</Text>
        <ColumnSpace/>
        <GuestConfirmationBox onConfirm={reload} verified={clientInfo?.phoneVerified ?? true}/>
        <ColumnSpace/>
        <Text>تغییر نام</Text>
        <ColumnSpace h={5}/>
        <NameSet name={name}/>
        <ColumnSpace/>
        <LogoutPressable viewClass={Button} scheme={"regular"} color={colors.get("red")}/>
        <Button scheme={"solid"} color={colors.get("primaryColor") as string} title={"بازگشت"} onPress={functionsContext.appNavigator.back}/>

    </DialogPage>
}

function NameSet(props: {name:string}){
    const colors = Colors.instanceNoServerColor(useContext(AppConfigContext).theme, useContext(AppConfigContext).color);

    return <View style={{
        flexDirection: "row",
    }}>
        <ClientNameSetComponents name={props.name}>
            <TextInput
                role="input"
                style={{flexGrow: 1}}
            />
            <RowSpace w={10}/>
            <TouchableOpacity
                // @ts-ignore
                role="button-save"
                style={{
                    backgroundColor: colors.get("primaryColor") as string,
                    borderRadius: 8,
                    width: 40,
                    height: 40,
                    justifyContent: "center",
                    alignItems: "center"
                }}>
                <FontAwesome icon={""} color={"#fff"}/>
            </TouchableOpacity>
        </ClientNameSetComponents>
    </View>
}

function GuestConfirmationBox(props: {onConfirm: ()=>void, verified: boolean}){

    return (!props.verified) ? <GuestConfirmationComponents onConfirm={props.onConfirm} verified={props.verified}>

        <Text>تنظیم شماره موبایل</Text>
        <ColumnSpace h={5}/>
        <TextInput role="input" />
        <Button role="main-button" style={{flexGrow: 1}} scheme={"regular"}/>
        <Button role="back-button" style={{flexGrow: 1}} scheme={"regular"}/>

    </GuestConfirmationComponents> : <></>
}
